import { useMemo } from 'react';

const BADGE_POSITION_RATIO = (1 + Math.SQRT1_2) / 2;

export const useAvatarBadgeOffset = (avatarSize: number) =>
  useMemo((): [number, number] => {
    const badgePosition = Math.round(avatarSize * BADGE_POSITION_RATIO);

    return [badgePosition - avatarSize, badgePosition];
  }, [avatarSize]);
